import type { Platform } from '@/types/platform'

export const platforms: Platform[] = [
  {
    id: '1',
    slug: 'intia',
    title: 'Intia',
    summary: 'AI-powered public visibility scanner for websites and SEO signals.',
    bullets: [
      'See what search engines and AI systems see on your site',
      'Get AI-assisted insights on indexability and content signals',
      'Identify SEO gaps with actionable recommendations',
    ],
    icon: 'Globe',
    iconImage: '/intia-icon.png',
    category: 'SEO / Developer Tools',
    featured: true,
    externalUrl: 'https://intia.app',
    ctaLabel: 'open intia.app',
  },
  {
    id: '2',
    slug: 'audexia',
    title: 'Audexia',
    summary: 'Voice-first productivity: turn spoken thoughts into actionable work.',
    bullets: [
      'Capture voice notes and meeting summaries hands-free',
      'AI extracts tasks and drafts emails for approval',
      'Offline-first: record anywhere, sync when connected',
      'Templates and routines for repeatable workflows',
    ],
    icon: 'ListChecks',
    iconImage: '/audexia-icon.png',
    category: 'Productivity',
    featured: true,
    externalUrl: 'https://audexia.app',
    ctaLabel: 'open audexia.app',
  },
  {
    id: '3',
    slug: '3rx',
    title: '3rx.co',
    summary: 'Unified growth stack: URLs, forms, cards, campaigns, analytics',
    bullets: [
      'Consolidate your growth tools into one platform',
      'Track every touchpoint in the customer journey',
      'Convert more leads with intelligent automation',
    ],
    icon: 'TrendingUp',
    category: 'Marketing',
    featured: true,
  },
  {
    id: '4',
    slug: 'ai-governance',
    title: 'AI Governance Platform',
    summary: 'Policy automation, compliance workflows, and risk oversight',
    bullets: [
      'Automate AI policy enforcement across teams',
      'Maintain audit trails for regulatory compliance',
      'Identify and mitigate AI-related risks proactively',
    ],
    icon: 'ShieldCheck',
    category: 'Governance',
    featured: true,
  },
  {
    id: '5',
    slug: 'fed-tracker',
    title: 'Fed Tracker Platform',
    summary: 'Capture, track, and analyze federal opportunities/contracts',
    bullets: [
      'Monitor federal contract opportunities in real-time',
      'Streamline compliance documentation workflows',
      'Maximize win rates with data-driven insights',
    ],
    icon: 'Building2',
    category: 'Government',
    featured: false,
  },
  {
    id: '6',
    slug: 'seo-platform',
    title: 'SEO Platform',
    summary: 'Client portal with transparent SEO projects, analytics, & billing',
    bullets: [
      'Give clients real-time visibility into SEO progress',
      'Automate reporting and reduce client communications',
      'Demonstrate ROI with clear, actionable metrics',
    ],
    icon: 'BarChart3',
    category: 'Marketing',
    featured: false,
  },
]
